// extracted by mini-css-extract-plugin
export default {"tooltip-icon":"twPod0FVFj_Qhm2ZmH5q"};